import React from 'react';

export default function Logo({ className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span
        aria-hidden="true"
        className="relative inline-flex h-8 w-8 items-center justify-center rounded-lg bg-ink-900 text-white"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4"
        >
          <path d="M3 12h3l2-5 4 10 2-5h7" />
        </svg>
      </span>
      <span className="font-semibold tracking-tightish text-ink-900">
        Vibe<span className="text-ink-500"> Engine</span>
      </span>
    </div>
  );
}
